"use client";

import React, { FC, Fragment } from "react";
import CurrencyIcon from "@/common/core/icons/CurrencyIcon";
import { CURRENCY_REGEX } from "@/apiUtils/commonUtils";

interface RenderCurrencyInTextProps {
  text?: string;
  className?: string;
  iconClassName?: string;
}

/**
 * RenderCurrencyInText - Replaces currency codes (AED, SAR, د.إ, ر.س) 
 * within a string with the font-based CurrencyIcon component.
 */
const RenderCurrencyInText: FC<RenderCurrencyInTextProps> = ({ 
  text, 
  className,
  iconClassName 
}) => {
  if (!text) return null;

  // Use the centralized regex for consistency
  const parts = text.split(CURRENCY_REGEX);

  return (
    <span className={className}>
      {parts.map((part, index) => {
        if (part.match(CURRENCY_REGEX)) {
          return (
            <CurrencyIcon 
              key={`${part}-${index}`} 
              currency={part} 
              className={iconClassName} 
            />
          );
        }
        return <Fragment key={index}>{part}</Fragment>;
      })}
    </span>
  );
};

export default RenderCurrencyInText;
